import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {Params} from '@angular/router';
import {Config} from '../..';
import {PaginationControlsDirective} from 'ngx-pagination';

export interface PaginationRange {
  page: number;
  limit: number;
}

@Component({
  selector: 'pagination',
  templateUrl: './pagination.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaginationComponent implements OnChanges {
  @ViewChild('paginationDirective')
  paginationDirective: PaginationControlsDirective;
  @ViewChild('paginationRange') paginationRange;
  @Input() pagination;
  @Input() config: Config;
  @Input() id;
  /**
   * Страницы — настоящие ссылки (`routerLink` с `?page=` в текущем адресе), а не кнопки на клик.
   * Нужно публичным листингам, которые обходит поисковый робот (хаб `/list`): по `<a>` без
   * `href` он дальше первой страницы не пройдёт. По умолчанию выключено — остальные таблицы
   * работают по-прежнему через `update`. Переход меняет только query, перезагрузку листинг делает
   * сам по `queryParams`; выпадающий «Выводить по» в обоих режимах идёт через `update`.
   */
  @Input() linkPages = false;
  @Output() readonly update: EventEmitter<PaginationRange> = new EventEmitter();

  public ranges: number[] = [5, 10, 25, 50, 100, 250];
  public selectedLimit: number;
  public showRange = false;
  public screenReaderPaginationLabel = 'Pagination';
  public screenReaderPageLabel = 'page';
  public screenReaderCurrentLabel = 'You are on page';
  public previousLabel = '';
  public nextLabel = '';
  public directionLinks = true;
  public maxSize = 5;

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any): void {
    if (this.paginationRange && !this.paginationRange.nativeElement.contains(targetElement)) {
      this.showRange = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { config } = changes;
    if (config && config.currentValue) {
      this.selectedLimit = this.config.rows;
    }
  }

  onPageChange(page: number): void {
    this.update.emit({
      page,
      limit: this.getLimit(),
    });
  }

  getLimit(): number {
    return this.pagination?.limit || this.selectedLimit;
  }

  /** Query ссылки на страницу для `linkPages`: первая — без `page`, это и есть канонический адрес. */
  pageQuery(page: number): Params {
    return {page: page > 1 ? page : null};
  }

  toggleDropdown(): void {
    this.showRange = !this.showRange;
  }

  changeLimit(limit: number, callFromAPI: boolean): void {
    if (!callFromAPI) {
      this.showRange = !this.showRange;
    }
    this.selectedLimit = limit;
    this.update.emit({
      page: 1,
      limit,
    });
  }
}
